import { SartellLogo } from "../components/Logo";
import { TeamBadge } from "../components/TeamBadge";

/* Landing screen for a family magic link: every one of this parent's players,
   grouped by team. The whole point is that a parent with kids on two different
   teams sees them together — today that's two passcodes and two sessions. */
export function FamilyScreen({ email, players, onSelect, onLogout }) {
  const byTeam = players.reduce((acc, p) => {
    (acc[p.team.id] = acc[p.team.id] || { team: p.team, players: [] }).players.push(p);
    return acc;
  }, {});
  const teams = Object.values(byTeam);
  const multiTeam = teams.length > 1;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-white">
      <div className="max-w-2xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex flex-col items-center text-center">
          <SartellLogo size="lg" />
        </div>

        <div className="mt-8">
          <h2 className="text-lg font-bold text-gray-800">
            {players.length === 1 ? "Your player" : "Your players"}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Pick a player to mark the days they can’t make it.
            {multiTeam && " They’re on different teams — you can update both from here."}
          </p>
        </div>

        <div className="mt-5 space-y-5">
          {teams.map(({ team, players: kids }) => (
            <div key={team.id}>
              <div className="flex items-center gap-2 mb-2">
                <TeamBadge team={team} size="sm" />
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-gray-700 truncate">{team.name}</div>
                  {(team.ageGroup || team.season) && (
                    <div className="text-xs text-gray-400">
                      {[team.ageGroup, team.season].filter(Boolean).join(" · ")}
                    </div>
                  )}
                </div>
              </div>
              <div className="space-y-2">
                {kids.map((p) => (
                  <button
                    key={`${p.team.id}:${p.playerName}`}
                    onClick={() => onSelect(p)}
                    className="w-full flex items-center justify-between gap-3 rounded-xl bg-white border
                               border-slate-200 px-4 py-3 text-left shadow-sm hover:border-blue-300
                               hover:shadow transition focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <span className="flex items-center gap-3 min-w-0">
                      {p.jerseyNumber && (
                        <span className="shrink-0 h-8 w-8 rounded-full bg-blue-50 text-blue-700
                                         text-sm font-bold flex items-center justify-center">
                          {p.jerseyNumber}
                        </span>
                      )}
                      <span className="font-medium text-gray-800 truncate">{p.playerName}</span>
                    </span>
                    <span className="shrink-0 text-sm font-semibold text-blue-600">Set dates →</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-400">
            Signed in as {email}. Bookmark this page — your link keeps working all season.
          </p>
          <div className="mt-2 flex items-center justify-center gap-4">
            <a href="/help/availability" className="text-xs text-blue-600 hover:text-blue-800 font-medium">
              Help
            </a>
            {onLogout && (
              <button onClick={onLogout} className="text-xs text-gray-400 hover:text-gray-600 underline">
                Not you? Start over
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
